module.exports = __webpack_public_path__ + "officialStatic/img/detail-three-bg.f94616b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/solution/detail-three-bg.png
// module id = dtqV
// module chunks = 0